var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H7.33333C6.6 18 6 17.4 6 16.6667V7.33333C6 6.6 6.6 6 7.33333 6H10C10.7333 6 11.3333 6.6 11.3333 7.33333V16.6667C11.3333 17.4 10.7333 18 10 18ZM14 18H16.6667C17.4 18 18 17.4 18 16.6667V13.3333C18 12.6 17.4 12 16.6667 12H14C13.2667 12 12.6667 12.6 12.6667 13.3333V16.6667C12.6667 17.4 13.2667 18 14 18ZM18 9.33333V7.33333C18 6.6 17.4 6 16.6667 6H14C13.2667 6 12.6667 6.6 12.6667 7.33333V9.33333C12.6667 10.0667 13.2667 10.6667 14 10.6667H16.6667C17.4 10.6667 18 10.0667 18 9.33333Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboards);
export default __webpack_public_path__ + "static/media/dashboards.972f873eb5b7097fc04d7177f12fd5eb.svg";
export { ForwardRef as ReactComponent };